type GetBrowserLocaleForResolvedLanguageOptions = {
  detectedLocale: string;
  isClient: boolean;
  isUserAuthenticated: boolean;
  liveBrowserLocale?: string;
  userPreferencesIsFetched: boolean;
};

// Picks the browser locale that resolveLanguage should consider. We only trust
// the live navigator locale once the client has mounted (avoids SSR/hydration
// mismatch) and, for authenticated users, once preferences have been fetched
// (avoids briefly using the browser locale before a manual preference loads).
// The manual-vs-browser decision itself lives in resolveLanguage, which ignores
// this value entirely when a manual preference is set.
export function getBrowserLocaleForResolvedLanguage({
  detectedLocale,
  isClient,
  isUserAuthenticated,
  liveBrowserLocale,
  userPreferencesIsFetched,
}: GetBrowserLocaleForResolvedLanguageOptions): string {
  const shouldUseLiveBrowserLocale = isClient && (!isUserAuthenticated || userPreferencesIsFetched);

  if (shouldUseLiveBrowserLocale && liveBrowserLocale) {
    return liveBrowserLocale;
  }

  return detectedLocale;
}
